<template>
  <div class="audioAnalysis_main">
    <div class="audioAnalysis_Content">
      <div class="audioAnalysis_part2">
        <div class="titleBox">
          <span>操作日志</span>
        </div>

        <div class="top">
          <span>设备</span>
          <el-select
            class="top-select"
            clearable
            filterable
            v-model="elevatorId"
            placeholder="请选择"
          >
            <el-option
              v-for="item in elevatorList"
              :key="item.id"
              :label="item.remark"
              :value="item.id"
            >
            </el-option>
          </el-select>
          <span>位置</span>
          <el-input type="text" v-model="position"></el-input>
          <div class="dateP">
            <datePicker
              :disabledDateNum="7"
              :disabledDate="true"
              :dateValue="dateValue"
              align="center"
              @confirmDate="confirmDate"
            />
          </div>
          <button class="btn-1" @click="getWarningList">查询</button>
        </div>

        <div style=" width: 99%">
          <!-- <div style="flex: 1; overflow: hidden; width: 99%"> -->
          <el-table
            size="mini"
            ref="Table"
            :data="warningList"
            class="Table"
            :highlight-current-row="true"
            style="padding: 0 1.5%; box-sizing: border-box"

            :header-cell-style="{
              fontSize: '0.875rem',
              color: 'rgba(127, 132, 136, 1)',
              borderColor: '#244447',
              backgroundColor: 'rgba(180, 180, 180, .1)',
              height: '3.375rem',

            }"
            :row-style="{
              fontSize: '0.875rem',
              color: '#B4B4B4',
              height: '3rem',
            }"
          >
            <el-table-column
              header-align="left"
              align="left"
              prop="remark"
              label="电梯名"
            >
            </el-table-column>
            <el-table-column
              header-align="left"
              align="left"
              prop="position"
              label="预警位置"
            >
            </el-table-column>
            <el-table-column
              header-align="left"
              align="left"
              label="处理状态"
            >
            <template slot-scope="scope">
              <span>{{ getstatusName(scope.row.status) }}</span>
            </template>
            </el-table-column>
            <el-table-column
              header-align="left"
              align="left"
              prop="warningTime"
              label="预警时间"
            >
            </el-table-column>
            <el-table-column
              header-align="left"
              align="left"
              prop="resolveTime"
              label="操作时间"
            >
            </el-table-column>
            <!-- <el-table-column
              header-align="left"
              align="left"
              label="操作"
            >
            <template slot-scope="scope">
              <span>编辑</span>
            </template>
            </el-table-column> -->
          </el-table>
          <!-- </div> -->
        </div>
        <Pagination
          style="margin: 0px auto; display: table"
          :total="total"
          :page.sync="pageNo"
          :limit.sync="pageSize"
          @pagination="getWarningList"
        ></Pagination>
      </div>
    </div>
    <solveDialog ref="solveDialog"></solveDialog>
  </div>
</template>
  
  <script>
import containerHeader from "@/components/container_header.vue";
import lineChart from "@/components/lineChart.vue";
import pieChart from "@/components/pieChart.vue";
import datePicker from "@/components/datePicker.vue";
import Pagination from "@/components/Pagination.vue";
import solveDialog from "@/components/solveDialog.vue";
import axios from "axios";

export default {
  components: {
    containerHeader,
    lineChart,
    pieChart,
    datePicker,
    Pagination,
    solveDialog
  },
  data() {
    return {
      curItem: {},
      popUpShow: false,
      positionStyle: { top: "0px", left: "0px" },
      options: [],
      value: "",
      filteredData: [],
      elevatorList: [
        { label: "一号电梯", value: 1 },
        { label: "二号电梯", value: 2 },
      ],
      liftList: [
        {
          name: "日立1号楼左梯",
          id: 1,
          status: 1,
        },
        {
          name: "日立1号楼右梯",
          id: 2,
          status: 3,
        },
        {
          name: "日立2号楼左梯",
          id: 3,
          status: 2,
        },
        {
          name: "日立2号楼右梯",
          id: 4,
          status: 1,
        },
        {
          name: "日立3号楼左梯",
          id: 5,
          status: 3,
        },
        {
          name: "日立3号楼右梯",
          id: 6,
          status: 2,
        },
        {
          name: "日立4号楼左梯",
          id: 7,
          status: 1,
        },
        {
          name: "日立4号楼右梯",
          id: 8,
          status: 1,
        },
        {
          name: "日立5号楼左梯",
          id: 9,
          status: 2,
        },
        {
          name: "日立5号楼右梯",
          id: 10,
          status: 1,
        },
      ],
      flag: 1, //1是预警列表，2是设备列表,
      warningList: [],
      sensorList: [],
      //datePick参数
      dateValue: [,],
      maxTime: "",
      minTime: "",
      interval: "",
      pageNo: 1,
      pageSize: 10,
      total: 0,
      site: "",
      position: "",
      elevatorId: "",
    };
  },

  mounted() {
    this.getelevatorList();
    this.getWarningList();
    this.dateValue = [
      //间隔24小时
      new Date(
        new Date().getTime() - 3600 * this.$store.state.timeRange * 1000
      ),
      new Date(),
    ];
    // this.maxTime = commonUtils.timeFormat(new Date());
    // this.minTime = commonUtils.timeFormat(
    //   new Date(new Date().getTime() - 3600 * this.$store.state.timeRange * 1000)
    // );
  },

  methods: {
    getstatusName(status) {
      switch (status) {
        case 1:
          return "未处理";
          case 2:
          return "忽略";
          case 3:
          return "已处理";
      }
    },
    getelevatorList() {
      this.$api.elevator.list().then((res) => {
        if (res.code == 200) {
          this.elevatorList = res.data;
          // this.getSensorList(this.curElevatorID);
        }
      });
    },
    getWarningList() {
      const params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        elevatorId: this.elevatorId,
        startTime: this.minTime,
        endTime: this.maxTime,
        position: this.position,
        site: this.site,
        isUntreated: 0,
      };
      this.$api.warning.page(params).then((res) => {
        console.log(res);
        if (res.code == 200) {
          this.warningList = res.data.records;
          this.total = res.data.total;
        }
      });
    },
    confirmDate(min, max) {
      // if (this.interval.includes("s")) {
      //   if (this.judgeDateTime(min, max)) {
      //     return;
      //   }
      // }

      if (min) {
        //选择时间
        this.maxTime = max;
        this.minTime = min;
      } else {
        //清空时间，取默认
        const num = this.dataType != 3 ? 1 : 24 * 7;

        this.dateValue = [
          new Date(new Date().getTime() - 3600 * num * 1000),
          new Date(),
        ];

        this.maxTime = commonUtils.timeFormat(new Date());
        this.minTime = commonUtils.timeFormat(
          new Date(new Date().getTime() - 3600 * num * 1000)
        );
      }

      let diffMinutes = this.$moment(this.maxTime).diff(
        this.$moment(this.minTime),
        "minutes"
      );
      if (diffMinutes <= 30) {
        this.interval = "1s";
      } else if (diffMinutes < 60) {
        this.interval = "5s";
      } else if (diffMinutes < 6 * 60) {
        this.interval = "10s";
      } else if (diffMinutes < 24 * 3 * 60) {
        this.interval = "1m";
      } else if (diffMinutes < 24 * 7 * 60) {
        this.interval = "5m";
      } else {
        this.interval = "1h";
      }

      // this.chartShowDate = diffMinutes > 24 * 60;
    },

    getSensorListList() {
      this.$api.sensor.list(params).then((res) => {
        if (res.code == 200) {
          this.sensorList = res.data.records;
        }
      });
    },

    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
  },
  computed: {},
};
</script>
  
  <style lang="less" scoped>
.audioAnalysis_main {
  width: 100%;
  height: 100%;
  font-size: 1.5rem;
  z-index: 15;
  overflow: auto;
  box-sizing: border-box;
  display: flex;
  /deep/ .el-input__inner {
    height: 1.5rem !important;
    font-size: 0.875rem !important;
    background: var(--input-bg);
    border-color: var(--input-border-color);
    color: rgba(127, 132, 136, 1);
    border-radius: 0px;
  }
  /* 清除表格横线 */
  /deep/ .el-table__row > td,
  th {
    border-color: var(--tableLine-color) ;

  }
}
.titleBox {
  display: flex;
  align-items: center;
  margin: 0.8125rem 0rem 0rem 1.5rem;
  border-left: 1px rgb(68, 215, 182) solid;

  span {
    width: 6.25rem;
    height: 1rem;
    font-size: 1rem;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    font-weight: 400;
    color: rgb(68, 215, 182);
    line-height: 1.125rem;
    padding-left: 1.25rem;
  }
}

.audioAnalysis_Content {
  flex: 1;
  display: flex;
  flex-direction: column;
  .el-input__inner {
    width: 13.4375rem;
    height: 2.5rem !important;
    line-height: 2.5rem !important;
    font-size: 0.9375rem !important;
  }
  .el-select {
    width: 13.4375rem !important;
    height: 2.5rem !important;
    line-height: 2.5rem !important;
  }
  .el-input {
    width: 13.4375rem !important;
    height: 2.5rem !important;
    line-height: 2.5rem !important;
    font-size: 0.9375rem !important;
  }

  .audioAnalysis_part2 {
    background: var(--cardbg-color);
    flex: 1;
    width: 100%;
    .top {
      padding: 1.375rem;
      display: flex;
      align-items: center;
      /deep/ .el-input__inner {
    height: 2.5rem !important;
    font-size: 0.875rem !important;
    background: var(--input-bg) !important;
    color: var(--white-and-green) !important;
    border-color: #244447;
  }
      span {
        width: 3.125rem;
        height: 1rem;
        font-size: 1rem;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: rgb(68, 215, 182);
        line-height: 1.125rem;
        padding-left: 1.25rem;
      }
    }

    .dateP {
      height: 2.5rem;
      display: flex;
      align-items: center;
      justify-content: center;
      padding-left: 1.25rem;
      /deep/ .el-date-editor .el-range__close-icon {
        line-height: 1.5rem;
      }

      /deep/ .el-input__icon {
        width: 1.5625rem;
      }

      /deep/ .el-range-editor--small .el-range-input {
        font-size: 0.875rem;
      }

      /deep/ .el-range-editor--small .el-range-separator {
        line-height: 1.875rem;
        font-size: 0.8125rem;
      }

      /deep/ .el-date-editor .el-range__icon {
        line-height: 1.5rem;
        font-size: 0.875rem;
      }

      /deep/ .el-radio-button__inner {
        background: rgba(8, 17, 24, 0.21);
        border: 0.125rem solid #c0e9ff !important;

        color: #c0e9ff;
      }

      /deep/ .el-range-editor--small.el-input__inner {
        border: 0.125rem solid #244447!important;
      }

      /deep/ .el-icon-time:before {
        color: #244447;
      }

      /deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
        border: 0.125rem solid #d3fbff;
        background: rgba(211, 251, 255, 0.5);
        box-shadow: -0.0625rem 0 0 0 #d3fbff;
      }

      /deep/ .el-range-editor--small.el-input__inner {
        height: 2.5rem !important;
        width: 24.0625rem !important;
        background: var(--input-bg) !important;
      }

      /deep/ .el-range-editor--small .el-range-input {
        background: transparent;
      }

      /deep/ .el-range-editor--small .el-range-separator {
        color: #d3fbff;
      }
    }
  }
}
.btn-1 {
  margin-left: 40px;
  width: 75px;
  height: 30px;
  background: #44d7b6;
  border-radius: 2px;
  color: #ffffff;
  border: none;
  cursor: pointer;
}
.btn-1:hover {
  background: #66f8d7;
}
.btn-1:active {
  background: #299f85;
}
@media screen and (max-width: 1440px) {
  .audioAnalysis_main {
    width: 100%;
    height: 100%;
    font-size: 24px;
    z-index: 15;
    overflow: auto;
    box-sizing: border-box;
    display: flex;
    /deep/ .el-input__inner {
      height: 25px !important;
      font-size: 14px !important;
    }
  }

  .audioAnalysis_Content {
    flex: 2.5;
    display: flex;
    flex-direction: column;

    .el-select {
      width: 215px !important;
      height: 40px !important;
      line-height: 40px !important;
    }
    .el-input__inner {
      width: 215px !important;
      height: 40px !important;
      line-height: 40px !important;
      font-size: 15px !important;
    }

    .el-input {
      width: 215px !important;
      height: 40px !important;
      line-height: 40px !important;
      font-size: 15px !important;
    }

    .titleBox {
      display: flex;
      align-items: center;
      margin: 13px 0px 0px 24px;
      border-left: 1px rgb(68, 215, 182) solid;

      span {
        width: 100px;
        height: 16px;
        font-size: 16px;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: rgb(68, 215, 182);
        line-height: 18px;
        padding-left: 20px;
      }
    }

    .audioAnalysis_part2 {
      background: var(--cardbg-color);
      flex: 1;
      width: 100%;
      .top {
        padding: 22px;
        display: flex;
        align-items: center;
        /deep/ .el-input__inner {
      height: 40px !important;
      font-size: 14px !important;
    }
        span {
          width: 50px;
          height: 16px;
          font-size: 16px;
          font-family: SourceHanSansCN-Regular, SourceHanSansCN;
          font-weight: 400;
          color: rgb(68, 215, 182);
          line-height: 18px;
          padding-left: 20px;
        }
      }
      .dateP {
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding-left: 20px;
        /deep/ .el-date-editor .el-range__close-icon {
          line-height: 24px;
        }

        /deep/ .el-input__icon {
          width: 25px;
        }

        /deep/ .el-range-editor--small .el-range-input {
          font-size: 14px;
        }

        /deep/ .el-range-editor--small .el-range-separator {
          line-height: 30px;
          font-size: 13px;
        }

        /deep/ .el-date-editor .el-range__icon {
          line-height: 24px;
          font-size: 14px;
        }

        /deep/ .el-radio-button__inner {
          background: rgba(8, 17, 24, 0.21);
          border: 2px solid #c0e9ff !important;

          color: #c0e9ff;
        }

        /deep/ .el-range-editor--small.el-input__inner {
          border: 2px solid #244447!important;
        }

        /deep/ .el-icon-time:before {
          color: #244447;
        }

        /deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
          border: 2px solid #d3fbff;
          background: rgba(211, 251, 255, 0.5);
          box-shadow: -1px 0 0 0 #d3fbff;
        }

        /deep/ .el-range-editor--small.el-input__inner {
          height: 40px !important;
          width: 385px !important;
          background: var(--input-bg) !important;
        }

        /deep/ .el-range-editor--small .el-range-input {
          background: transparent;
        }

        /deep/ .el-range-editor--small .el-range-separator {
          color: #d3fbff;
        }
      }
    }
  }
}
</style>
  
    


// WEBPACK FOOTER //
// src/pages/systemSet/operationSet/index.vue